import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2.6a9.4 9.4 0 1 0 0 18.8 9.4 9.4 0 0 0 0-18.8ZM1.4 12C1.4 6.146 6.146 1.4 12 1.4c5.854 0 10.6 4.746 10.6 10.6 0 5.854-4.746 10.6-10.6 10.6-5.854 0-10.6-4.746-10.6-10.6ZM12 10.4a.6.6 0 0 1 .6.6v5a.6.6 0 1 1-1.2 0v-5a.6.6 0 0 1 .6-.6Z"
      clip-rule="evenodd"
    />
    <path fill="currentColor" d="M12 7.15a.85.85 0 0 0 0 1.7h.01a.85.85 0 1 0 0-1.7H12Z" />
  </svg>
`;
